import { render, staticRenderFns } from "./we.vue?vue&type=template&id=3da0554e&scoped=true&lang=pug&"
import script from "./we.vue?vue&type=script&lang=js&"
export * from "./we.vue?vue&type=script&lang=js&"
import style0 from "./we.vue?vue&type=style&index=0&id=3da0554e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da0554e",
  null
  
)

export default component.exports